import DetailField from './DetailField';

export default DetailField;
